<template>
  <fragment>
    <!--LIST-->
    <td
      v-if="$store.state.app.showAPIs"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAPIsVer"
          hide-details
          class="my-1"
          @click="checkAllListBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--EDIT-->
    <td
      v-if="$store.state.app.showAPIs"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAPIsEdit"
          hide-details
          class="my-1"
          @click="checkAllEditBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--CREATE-->
    <td
      v-if="$store.state.app.showAPIs"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAPIsCreate"
          hide-details
          class="my-1"
          @click="checkAllCreateBooking()"
        ></v-checkbox>
      </div>
    </td>
    <!--DESTROY-->
    <td
      v-if="$store.state.app.showAPIs"
      :key="Math.random() * (index + 1)"
      class="paddMine"
    >
      <div class="d-flex justify-center">
        <v-checkbox
          v-model="sourcePermisos[index].all.checkboxAPIsDelete"
          hide-details
          class="my-1"
          @click="checkAllDestroyBooking()"
        ></v-checkbox>
      </div>
    </td>
    <td
      :key="Math.random() * (index + 1)"
      style="min-width: 50px;"
    ></td>
  </fragment>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    index: {
      type: Number,
    },
  },
  computed: {
    ...mapState({
      sourcePermisos: state => state.app.sourcePermisos,
    }),
  },
  methods: {
    checkAllListBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAPIs = false
      if (this.sourcePermisos[this.index].all.checkboxAPIsVer) {
        this.sourcePermisos[this.index].permisos.push('api_keys:list')
        this.sourcePermisos[this.index].permisos.push('api_tti:list')
        this.sourcePermisos[this.index].permisos.push('api_amadeus:list')
        this.sourcePermisos[this.index].permisos.push('api_redsys:list')
        this.sourcePermisos[this.index].permisos.push('api_sibs:list')
        this.sourcePermisos[this.index].permisos.push('api_authorize_net:list')
        this.sourcePermisos[this.index].permisos.push('currencyapi:list')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'api_keys:list'
            && e !== 'api_tti:list'
            && e !== 'api_amadeus:list'
            && e !== 'api_redsys:list'
            && e !== 'api_sibs:list'
            && e !== 'api_authorize_net:list'
            && e !== 'currencyapi:list',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAPIs = !this.$store.state.app.showAPIs
      }, 10)
    },
    checkAllEditBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAPIs = false
      if (this.sourcePermisos[this.index].all.checkboxAPIsEdit) {
        this.sourcePermisos[this.index].permisos.push('api_keys:edit')
        this.sourcePermisos[this.index].permisos.push('api_tti:edit')
        this.sourcePermisos[this.index].permisos.push('api_amadeus:edit')
        this.sourcePermisos[this.index].permisos.push('api_redsys:edit')
        this.sourcePermisos[this.index].permisos.push('api_sibs:edit')
        this.sourcePermisos[this.index].permisos.push('api_authorize_net:edit')
        this.sourcePermisos[this.index].permisos.push('currencyapi:edit')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'api_keys:edit'
            && e !== 'api_tti:edit'
            && e !== 'api_amadeus:edit'
            && e !== 'api_redsys:edit'
            && e !== 'api_sibs:edit'
            && e !== 'api_authorize_net:edit'
            && e !== 'currencyapi:edit',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAPIs = !this.$store.state.app.showAPIs
      }, 10)
    },
    checkAllCreateBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAPIs = false
      if (this.sourcePermisos[this.index].all.checkboxAPIsCreate) {
        this.sourcePermisos[this.index].permisos.push('api_keys:create')
        this.sourcePermisos[this.index].permisos.push('api_tti:create')
        this.sourcePermisos[this.index].permisos.push('api_amadeus:create')
        this.sourcePermisos[this.index].permisos.push('api_redsys:create')
        this.sourcePermisos[this.index].permisos.push('api_sibs:create')
        this.sourcePermisos[this.index].permisos.push('api_authorize_net:create')
        this.sourcePermisos[this.index].permisos.push('currencyapi:create')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'api_keys:create'
            && e !== 'api_tti:create'
            && e !== 'api_amadeus:create'
            && e !== 'api_redsys:create'
            && e !== 'api_sibs:create'
            && e !== 'api_authorize_net:create'
            && e !== 'currencyapi:create',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAPIs = !this.$store.state.app.showAPIs
      }, 10)
    },
    checkAllDestroyBooking() {
      const { permisos } = this.sourcePermisos[this.index]
      this.$store.state.app.showAPIs = false
      if (this.sourcePermisos[this.index].all.checkboxAPIsDelete) {
        this.sourcePermisos[this.index].permisos.push('api_keys:destroy')
        this.sourcePermisos[this.index].permisos.push('api_tti:destroy')
        this.sourcePermisos[this.index].permisos.push('api_amadeus:destroy')
        this.sourcePermisos[this.index].permisos.push('api_redsys:destroy')
        this.sourcePermisos[this.index].permisos.push('api_sibs:destroy')
        this.sourcePermisos[this.index].permisos.push('api_authorize_net:destroy')
        this.sourcePermisos[this.index].permisos.push('currencyapi:destroy')
      } else {
        this.sourcePermisos[this.index].permisos = permisos.filter(
          e => e !== 'api_keys:destroy'
            && e !== 'api_tti:destroy'
            && e !== 'api_amadeus:destroy'
            && e !== 'api_redsys:destroy'
            && e !== 'api_sibs:destroy'
            && e !== 'api_authorize_net:destroy'
            && e !== 'currencyapi:destroy',
        )
      }
      setTimeout(() => {
        this.$store.state.app.showAPIs = !this.$store.state.app.showAPIs
      }, 10)
    },
  },
}
</script>
